<section id="hero" data-hero-collage class="hero-collage">
  <div class="hero-collage__glow hero-collage__glow--one" aria-hidden="true"></div>
  <div class="hero-collage__glow hero-collage__glow--two" aria-hidden="true"></div>
  <div class="hero-collage__grid" aria-hidden="true"></div>

  <div class="hero-collage__inner">
    <div data-hero-copy class="hero-copy min-w-0">
      <div class="hero-copy__badge">
        <span aria-hidden="true"></span>
        {{ content.badge }}
      </div>

      <h1 class="break-words text-white">
        {{ content.title }}
        <span>{{ content.highlightedTitle }}</span>
      </h1>

      <p class="hero-copy__description">{{ content.description }}</p>

      <div class="hero-copy__actions">
        <button type="button" class="hero-copy__primary" (click)="navigate.emit(content.cards[0].anchor)">
          Khám phá ngành hàng
          <mat-icon svgIcon="hero:arrow_forward"></mat-icon>
        </button>
        <a class="hero-copy__secondary" href="#warranty">Tra cứu bảo hành</a>
      </div>

      <div class="hero-copy__metrics">
        <div data-hero-metric *ngFor="let metric of content.metrics" class="min-w-0">
          <strong>{{ metric.value }}</strong>
          <span>{{ metric.label }}</span>
        </div>
      </div>
    </div>

    <div data-hero-media class="hero-media min-w-0">
      <button
        *ngFor="let card of content.cards; let index = index; trackBy: trackCard"
        data-industry-card
        type="button"
        class="hero-card"
        [class.hero-card--primary]="index === 0"
        [class.hero-card--machine]="card.kind === 'machine'"
        [class.hero-card--appliance]="card.kind === 'appliance'"
        (click)="navigate.emit(card.anchor)"
      >
        <img appImgFallback [src]="card.imageSrc" [alt]="card.imageAlt" />
        <span class="hero-card__veil" aria-hidden="true"></span>
        <span class="hero-card__content">
          <span class="hero-card__eyebrow" [ngClass]="themeClasses[card.kind].text">{{ card.eyebrow }}</span>
          <h2 class="text-white">{{ card.title }}</h2>
          <span data-industry-description class="hero-card__description">{{ card.description }}</span>
          <span data-industry-link class="hero-card__link">
            Xem ngành hàng
            <mat-icon svgIcon="hero:arrow_forward"></mat-icon>
          </span>
        </span>
      </button>

      <div class="hero-media__stamp" aria-hidden="true">
        <span>03</span>
        ngành hàng<br />một điểm đến
      </div>
    </div>
  </div>

  <div class="hero-collage__bridge" aria-hidden="true"></div>
</section>
